import { render } from "./AdminDashboardPanel.vue?vue&type=template&id=40c045dd&scoped=true"
import script from "./AdminDashboardPanel.vue?vue&type=script&lang=js"
export * from "./AdminDashboardPanel.vue?vue&type=script&lang=js"

import "./AdminDashboardPanel.vue?vue&type=style&index=0&id=40c045dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c045dd"]])

export default __exports__